import type { AlgoliaCompanyRecord } from '../../types/algolia-company-record';
import { parseBestCompaniesHubApiPayload } from './parse-best-companies-hub-api-payload';

let inflight: Promise<AlgoliaCompanyRecord[]> | null = null;

async function fetchBestCompaniesHubFromApiOnce(): Promise<AlgoliaCompanyRecord[]> {
  try {
    const res = await fetch('/api/best-companies-hub', {
      credentials: 'same-origin',
      headers: { accept: 'application/json' },
    });
    if (!res.ok) return [];
    const json: unknown = await res.json();
    return parseBestCompaniesHubApiPayload(json);
  } catch {
    return [];
  }
}

/**
 * Loads hub rankings in the browser when Vike did not pass SSR data (e.g. client-side navigation).
 * Concurrent callers share one request.
 */
export async function fetchBestCompaniesHubFromApi(): Promise<AlgoliaCompanyRecord[]> {
  if (!inflight) {
    inflight = fetchBestCompaniesHubFromApiOnce().finally(() => {
      inflight = null;
    });
  }
  return inflight;
}

/**
 * Start loading hub data early (e.g. hover on a link to `/best-companies`) — dedupes with the page hook.
 */
export function prefetchBestCompaniesHubFromApi(): void {
  if (typeof window === 'undefined') return;
  void fetchBestCompaniesHubFromApi();
}
